module.exports = __webpack_public_path__ + "img/siame.e03d2d7e.png";